/**
 * Unicode-safe base64 encoding.
 * Converts a UTF-8 string to a base64-encoded ASCII string.
 */
export function base64Encode(input: string): string {
	return btoa(
		encodeURIComponent(input).replaceAll(
			/%([0-9A-F]{2})/g,
			(_match, hex: string) => String.fromCodePoint(Number.parseInt(hex, 16)),
		),
	);
}

/**
 * Unicode-safe base64 decoding.
 * Converts a base64-encoded ASCII string back to a UTF-8 string.
 */
export function base64Decode(input: string): string {
	return decodeURIComponent(
		Array.from(
			atob(input),
			(char) => `%${(char.codePointAt(0) ?? 0).toString(16).padStart(2, "0")}`,
		).join(""),
	);
}
